module.exports = __webpack_public_path__ + "35874e0463c59159fec9c43a43bfaa99.svg";